if( typeof jQuery != 'undefined' ) {
/*global wpcf7, ajax_obj, __gaTracker, ga, grecaptcha*/

(function($) {
	var $body, $window, resizeTimer, windowWidth, windowHeight, lastWindowPos = 0, headerHeight;

	var fancyboxData = {
		loop: false,
		opacity: 'auto',
		margin: [0, 0],
		infobar: false,
		buttons: [
			//"zoom",
			//"share",
			//"slideShow",
			//"fullScreen",
			//"download",
			//"thumbs",
			"close",
		],
		slideShow: false,
		fullScreen: false,
		thumbs: false,
		smallBtn: 'auto',
		baseClass: 'true_fancybox',
		slideClass: 'true_fancybox_slide',
		spinnerTpl: '<div class="fancybox-loading"></div>',
		btnTpl: {
			smallBtn: '<div data-fancybox-close class="fancybox-close-small"></div>',
		},
		parentEl: 'body',
		touch: false,
		keyboard: false,
		focus: true,
		clickOutside: 'close',
	};
	var fancyboxDataVideo = {
		width: 1200,
		height: 675,
		loop: false,
		opacity: 'auto',
		margin: [0, 0],
		infobar: false,
		buttons: [
			//"zoom",
			//"share",
			//"slideShow",
			//"fullScreen",
			//"download",
			//"thumbs",
			"close",
		],
		slideShow: false,
		fullScreen: false,
		thumbs: false,
		closeBtn: true,
		smallBtn: 'auto',
		baseClass: 'iside_video_fancybox',
		slideClass: 'iside_video_fancybox_slide',
		spinnerTpl: '<div class="fancybox-loading"></div>',
		btnTpl: {
			smallBtn: '<div data-fancybox-close class="fancybox-close-small"></div>',
		},
		parentEl: 'body',
		touch: false,
		keyboard: false,
		focus: true,
		clickOutside: 'close',
		iframe: {
			css: {
				width: '1200px',
				height: '675px',
			},
		},
	};

	function resize() {
		windowWidth			= parseInt($window.width(),10);

		$('.wpb_column.window_right').each(function(){
			if( windowWidth < 768 ) {
				iside_extend_column_both($(this));
			} else {
				iside_extend_column_right($(this));
			}
		});
		$('.wpb_column.window_left').each(function(){
			if( windowWidth < 768 ) {
				iside_extend_column_both($(this));
			} else {
				iside_extend_column_left($(this));
			}
		});

		$('.wpb_single_image.align-window-left').each(function(){
			$(this).css({'margin-left':-1*($(this).parent().offset().left)});
		});
		$('.wpb_single_image.align-window-right').each(function(){
			$(this).css({'margin-right':-1*(windowWidth-$(this).parent().offset().left-$(this).parent().width())});
		});

		if( ! $('header.banner').length && ! $('header.site-header').length ) {
			headerHeight = $('header:not(.banner)').outerHeight(); // .banner is the default easee header

			$('.page-content').css('padding-top', parseInt(headerHeight)+'px');
		}

		return;
	}
	function scroll() {
		if( !$('header.banner').length ) {
			var windowPos = $window.scrollTop();

			if( windowPos < (windowHeight*0.4) || (windowPos + 50) < lastWindowPos ) {
				lastWindowPos = windowPos;
				$body.removeClass('hideHeader');
			} else if( windowPos >= (windowHeight*0.4) && windowPos > lastWindowPos ) {
				lastWindowPos = windowPos;
				$body.addClass('hideHeader');
			} else {
				setTimeout(function(){
					lastWindowPos = windowPos;
				},1000);
			}
		}

		return;
	}
	function resizeAndScroll() {
		resize();
		scroll();
	}
	$(function() {
		$body				= $( document.body );
		$window				= $( window );
		windowHeight		= parseInt($window.height(),10);

		var scrolled = false, resized = false;
		$window
			.on( 'scroll.iside', function() {
				scrolled = true;
			})
			.on( 'touchmove.iside', function() {
				scrolled = true;
			})
			.on( 'resize.iside', function() {
				resized = true;
			});
		$body.on( 'scroll', function() {
			scrolled = true;
		});

		resizeAndScroll();
		setInterval(function() {
			if( scrolled ) {
				scrolled = false;
				scroll();
			}
			if( resized ) {
				resized = false;
				clearTimeout( resizeTimer );
				resizeTimer = setTimeout( resizeAndScroll, 200 );
			}
		},100);

		for ( var i = 1; i < 4; i++ ) {
			setTimeout( resizeAndScroll, 150 * i );
		}
		if(window.location.hash) {
			for ( var j = 1; j < 3; j++ ) {
				setTimeout( function(){
					resizeAndScroll();
				}, 800 * j );
			}
		}

		/* Load contact lightboxes */
			$body.on('click', 'a.lightbox,button.lightbox', function() {
				var $this = $(this);
				var formId = 0;
				var classes = $this.attr('class').split(" ");
				var label = ( $(this).data('eventLabel') ) ? $(this).data('eventLabel') : window.location.pathname;

				// get form id for vc_btn
					formId = parseInt($this.data('form-id'),10);
					if( !formId || formId === 1 ) {
						if( classes.indexOf('vc_btn3') != -1 ) {
							for( var i=0; i<classes.length; i++ ) {
								if( classes[i].substr(0,17) == 'lightbox-form-id-' ) {
									formId = parseInt(classes[i].substr(17),10);
								}
							}
						}
					}
				if( formId || formId === 1 ) {
					var elId = 'lightbox-form-id-'+formId;
					if( $('#'+elId).length ) {
						$.fancybox.open({
								src: $('#'+elId),
								type : 'inline',
							},$.extend({}, fancyboxData));
					} else {
						$('#ajax_elements').append('<div id="'+elId+'" class="fancybox-content"></div>');

						var $instance = $('<div class="fancybox-container fancybox-show-controls fancybox-show-buttons fancybox-container--ready true-fancybox-custom-close"><div class="fancybox-bg"></div><div class="fancybox-controls"><div class="fancybox-buttons"><button data-fancybox-close="" class="fancybox-button fancybox-button--close" title="Close"></button></div></div><div class="fancybox-slider-wrap"><div class="fancybox-loading"></div></div></div>');
						$('body').prepend($instance);
						$.post(ajax_obj.url, {
							action: 'get_form',
							security: ajax_obj.btn_security,
							id: formId,
						}, function(data) {
							$('#'+elId).append(data);
							$instance.remove();
							$.fancybox.open({
								src: $('#'+elId),
								type : 'inline',
							}, $.extend({}, fancyboxData));
							iside_wpcf7InitiateForm(elId);

						}, "html");
					}
					iside_register_googleanalytics({
						eventCategory:'form',
						eventAction:'open in lightbox',
						eventLabel: label,
					});
				}
				else if( classes.indexOf('lightbox-video') != -1 ) {
					var video = $this.data('src');
					if( video ) {
						$.fancybox.open({
								type: 'iframe',
								src: video,
							},$.extend({}, fancyboxDataVideo));
					}
				} else if( classes.indexOf('lightbox-content') != -1 ) {
					var lightboxId = $this.data('lightbox-id');
					if( $('#'+lightboxId).length ) {
						$.fancybox.open({
								src:  $('#'+lightboxId),
								type : 'inline',
							},$.extend({}, fancyboxData));
					} else if( $(this).parent().find('.vc_btn-lightbox-content') ) {
						$.fancybox.open({
							src:  $(this).parent().find('.vc_btn-lightbox-content'),
							type : 'inline',
						},$.extend({}, fancyboxData));
					}
				}
				else if( classes.indexOf('lightbox-image') != -1 ) {
					var img = $this.data('src');
					if( img ) {
						$.fancybox.open({
								type: 'image',
								src: img,
							},$.extend({}, fancyboxData));
					}
				}
			});

		$('header.v2021').on('click', '.hamburger', function() {
			$body.toggleClass('menuopen');
		});

		if( $.isFunction( $.fn.tooltip ) ) {
			if( $('.iside_icon_text_block .list_icon.tooltip').length ) {
				$('.iside_icon_text_block .list_icon.tooltip').each(function() {
					$(this).tooltip({
						items: "svg",
						position: { my: "left bottom-5", at: "left top" },
						classes: {
							"ui-tooltip": ( $(this).data('tooltip-bg-color') ? $(this).data('tooltip-bg-color') : ''),
						},
						show: false,
						hide: false,
						content: function() {
							return $(this).closest('.list_icon.tooltip').data('tooltip');
						},
					});
				});
			}
			if( $('.iside_list .iside_list_item.tooltip').length ) {
				$('.iside_list .iside_list_item.tooltip').each(function() {
					$(this).tooltip({
						items: "svg",
						position: { my: "left bottom-5", at: "left top" },
						classes: {
							"ui-tooltip": ( $(this).data('tooltip-bg-color') ? $(this).data('tooltip-bg-color') : '') + ( $(this).data('tooltip-color') ? ' text-'+$(this).data('tooltip-color') : '' ),
						},
						show: false,
						hide: false,
						content: function() {
							return $(this).closest('.iside_list_item.tooltip').data('tooltip');
						},
					});
				});
			}
			if( $('.iside_inline_images span.tooltip').length ) {
				$('.iside_inline_images span.tooltip').each(function() {
					$(this).tooltip({
						items: "img, a",
						position: { my: "left bottom-5", at: "left top" },
						show: false,
						hide: false,
						content: function() {
							return $(this).closest('span.tooltip').data('tooltip');
						},
					});
				});
			}
		}

	});

	function iside_register_googleanalytics(data) {
		if( data.hitType && data.hitType == 'pageview' ) {
			data = $.extend({
					hitType: 'pageview',
					page: window.location.pathname,
				},data);
		} else {
			data = $.extend({
					hitType: 'event',
					eventCategory: 'button',
					eventAction: 'click',
					eventLabel: window.location.pathname,
				},data);
		}

		if( typeof __gaTracker === 'function' ) {
			__gaTracker('send', data);
		} else if( typeof ga === 'function' ) {
			ga('send', data);
		} else {
			return false;
		}
		return true;
	}

	function iside_wpcf7InitiateForm(elId) {
		elId = '#' + elId;
		var elIdForm = elId + ' form';

		if( typeof wpcf7 !== 'undefined' || wpcf7 !== null ) {
			if( typeof wpcf7.init === 'function' ) {
					wpcf7.init( $(elIdForm).get(0) );
				} else if( typeof wpcf7.initForm === 'function' ) {
					wpcf7.initForm( $(elIdForm) );
				} else {
					console.log('Sorry, no support for this ContactForm7 version.');
					return;
				}
		} else if( typeof $.fn.wpcf7InitForm != 'undefined' ) {
			$(elIdForm).wpcf7InitForm();
		}

		// Correction for action URL to remove ajax path
		var formUrl = $(elId + ' form').attr('action').split('#');
		$(elIdForm).attr('action', "#" + formUrl[1]);

		if( $(elIdForm + ' [name="g-recaptcha-response"]').length && ! $(elIdForm + ' [name="g-recaptcha-response"]').val() && typeof ajax_obj.sitekey != 'undefined'  && ajax_obj.sitekey.length ) {
			grecaptcha.execute(ajax_obj.sitekey, {action: 'contactForm'}).then(function(token) {
				$(elIdForm + ' [name="g-recaptcha-response"]').val(token);
			});
		}
	}

	function iside_extend_column_both($column) {
		var space = (windowWidth-$column.offset().left-$column.width()) / 2;

		$column.children('.vc_column-inner').css({'margin-left': -1*space,'margin-right': -1*space,'padding-left': space,'padding-right': space});
		if( $(this).closest('.vc_row.vc_inner').length ) {
			var padding = parseInt($(this).children('.vc_column-inner').css('padding-right'),10);
			if( (space+padding)/2 > padding ) {
				padding = (space+padding)/2;
			}
			space = padding;
			$(this).children('.vc_column-inner').css({'padding-left': space, 'padding-right': padding});
		}
	}

	function iside_extend_column_left($column) {
		var space = $column.offset().left + parseInt($column.css('padding-left'),10);
		$column.children('.vc_column-inner').css({'margin-left':-1*space,'padding-right': '','padding-left': space,'margin-right': parseInt($column.css('padding-right')) * -1});

		if( $(this).closest('.vc_row.vc_inner').length ) {
			var padding = parseInt($(this).children('.vc_column-inner').css('padding-right'),10);
			if( (space+padding)/2 > padding ) {
				padding = (space+padding)/2;
			}
			space = padding;
			$(this).children('.vc_column-inner').css({'padding-left': space, 'padding-right': padding});
		}
	}

	function iside_extend_column_right($column) {
		var space = (windowWidth-$column.offset().left-$column.width());
		$column.children('.vc_column-inner').css({'margin-right':-1*space,'padding-right': space,'padding-left': '','margin-left': parseInt($column.css('padding-left')) * -1});

		if( $column.closest('.vc_row.vc_inner').length ) {
			var padding = parseInt($(this).children('.vc_column-inner').css('padding-left'),10);
			if( (space+padding)/2 > padding ) {
				padding = (space+padding)/2;
			}
			space = padding;
			$(this).children('.vc_column-inner').css({'padding-right': space, 'padding-left': padding});
		}
	}
} )( jQuery );

}



// WEBPACK FOOTER //
// ./scripts/iside.js